import { Box, Typography } from "@mui/material";
import React from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { colorPrimary, textColor } from "../../Styles/Colors";

const Loader = ({ size = "medium", label = "Loading..." }) => {
  return (
    <Box sx={{ position: 'fixed', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1300 }}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 1,
          border: `none`,
          borderRadius: 1,
          color: colorPrimary || "#5B2BDB",
          background: "transparent",
        }}
      >
        <RefreshOutlinedIcon sx={{ fontSize: size === "small" ? 18 : 24 }} />
        <Typography
          sx={{ fontWeight: 500, fontSize: size === "small" ? 14 : 16 }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default Loader;
